/* ============================================================
   Veloura shared JS — cart-drawer add-to-cart flow, reveal
   observer, quick-buy buttons. Loaded deferred; guarded so
   multiple section script tags only initialize once.
   ============================================================ */
window.VelouraCart = window.VelouraCart || (function () {
  'use strict';

  /* Arm the reveal-on-scroll styles only once JS is confirmed running. */
  document.documentElement.classList.add('vh-js');

  function fallbackUrl(variantId, colors) {
    var url = '/cart/' + variantId + ':1';
    if (colors) url += '?attributes[Brush%20Colors]=' + encodeURIComponent(colors);
    return url;
  }

  /**
   * Add one unit of a variant with a "Brush Colors" line-item property
   * (colors only, e.g. "Pink" or "Pink + Purple") through the theme's
   * Dawn-style <cart-drawer>. Rejects on failure so callers can fall
   * back to the cart permalink.
   */
  function add(variantId, colors) {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    var sections = (drawer && drawer.getSectionsToRender)
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var properties = colors ? { 'Brush Colors': colors } : {};
    var body = {
      items: [{ id: variantId, quantity: 1, properties: properties }],
      sections: sections,
      sections_url: window.location.pathname
    };
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
      .then(function (res) {
        if (res.status === 422 || (res.data && res.data.status)) {
          throw new Error((res.data && res.data.description) || 'add_failed');
        }
        if (drawer && drawer.renderContents) {
          drawer.renderContents(res.data);
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'veloura', productVariantId: variantId, cartData: res.data });
            }
          } catch (e) { /* pub/sub optional */ }
        } else {
          window.location = fallbackUrl(variantId, colors);
        }
      });
  }

  /* Quick-buy buttons: <a data-vh-atc data-variant-id="…" data-colors="Pink"> */
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-vh-atc]') : null;
    if (!el) return;
    e.preventDefault();
    if (el.dataset.vhBusy) return;
    el.dataset.vhBusy = '1';
    var label = el.querySelector('[data-vh-atc-label]') || el;
    var prev = label.textContent;
    label.textContent = 'Adding…';
    add(el.dataset.variantId, el.dataset.colors || '')
      .then(function () { label.textContent = prev; })
      .catch(function () { window.location = fallbackUrl(el.dataset.variantId, el.dataset.colors || ''); })
      .then(function () { delete el.dataset.vhBusy; });
  });

  /* Reveal-on-scroll for .vh-reveal elements (idempotent per element) */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.vh-reveal:not([data-vh-observed])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); el.setAttribute('data-vh-observed', ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { el.setAttribute('data-vh-observed', ''); io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  } else {
    initReveal();
  }
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });

  return { add: add, fallbackUrl: fallbackUrl, initReveal: initReveal };
})();
